/* eslint-disable no-nested-ternary */
import PropTypes from "prop-types";
import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";
import DatePicker from "react-datepicker";
import { setColor, setFont } from "../../../../../assets/styles/styles";
import "react-datepicker/dist/react-datepicker.css";
import { ReactComponent as GreenFeatureCheckmark } from "../../../../landingPages/intraverseLandingPage/IntraverseHomeImages/GreenFeatureCheckmark.svg";
import { ReactComponent as RedCross } from "../../../../landingPages/intraverseLandingPage/IntraverseHomeImages/redCross.svg";
import {
    getUserProfileData,
    UpdateUserEmail,
    ConfirmPasswordReset,
    currentPasswordChecker,
    UpdateUserBirthday,
    UpdateUserProfileData,
    sendEventsLogCustomBody,
} from "../../../../../api/UserController";
import { default as Button } from "../../../../../components/common/button/Button";
import { updateEmail } from "../../../../../redux/actions/UserActions";
import { validateUsername } from "../../../../../utils/generalUtils";
import PasswordChecker from "../../../../login/PasswordChecker";
import Iconify from "../../../../../components/common/icon/Iconify";
import Chevron from "../../../../../assets/images/icons/Chevron.svg";
import EyeIcon from "../../../../../assets/images/icons/UC_Sprite_Icon_Eye.png";
import EyeSlashIcon from "../../../../../assets/images/icons/UC_Sprite_Icon_Eyeslash.png";
import CalendarIcon from "../../../../../assets/images/icons/UC_Sprite_Icon_Calendar.png";
import CopyIcon from "../../../../../assets/images/icons/UC_Sprite_Icon_Copy.png";
import MailIcon from "../../../../../assets/images/icons/UC_Sprite_Icon_Email.png";
import SystemAlert from "../../../../../assets/images/icons/SystemAlert.svg";
import { handleSpotifyAuth } from "../../../../../features/spotify/api/SpotifyController";
import FadeCard from "./FadeCard";

export function EditContentModal({
    handleClose,
    setCurrentBirthday,
    userEmail,
    isEmail,
    isPassword,
    isBirthday,
    isContactSupport,
    isRequestPro,
    isExitConsole,
    isDisconnectApp,
    isUserData,
    externalAppType,
}) {
    const dispatch = useDispatch();
    const token = useSelector((state) => state?.user?.token);
    const userId = useSelector((state) => state?.user?.userId);
    const isMobile = window.innerWidth <= 768;

    // Email states
    const [email, setEmail] = useState("");
    const [emailConfirm, setEmailConfirm] = useState("");

    // Error message state
    const [confirmMessage, setConfirmMessage] = useState("");

    // User Details states
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [country, setCountry] = useState("");
    const [gender, setGender] = useState("");
    const [username, setUsername] = useState("");
    const [currentUsername, setCurrentUsername] = useState("");
    const [isValidUsername, setIsValidUsername] = useState(true);
    const [isValidFirstName, setIsValidFirstName] = useState(true);
    const [isValidLastName, setIsValidLastName] = useState(true);

    // Birthday states
    const [birthday, setBirthday] = useState("");
    const [birthdayCounter, setBirthdayCounter] = useState(null);
    const [birthdaySupport, setBirthdaySupport] = useState(false);
    const [isBirthdayInputValid, setIsBirthdayInputValid] = useState(false);

    // for disabling button when there is no change compared to inital value
    const [initialFirstName, setInitialFirstName] = useState("");
    const [initialLastName, setInitialLastName] = useState("");
    const [initialCountry, setInitialCountry] = useState("");
    const [initialBirthday, setInitialBirthday] = useState(null);
    const [errorMessage, setErrorMessage] = useState("");

    // Password states
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [newPasswordConfirm, setNewPasswordConfirm] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [isPrevPasswordValid, setIsPrevPasswordValid] = useState(true);

    const [redResponseBackground, setRedResponseBackground] = useState(false);

    const dateInputRef = useRef(false);

    const toggleShowPassword = () => {
        setShowPassword(!showPassword);
    };

    // Password checker states
    const [lengthError, setLengthError] = useState(true);
    const [uppercaseError, setUppercaseError] = useState(true);
    const [numberError, setNumbersError] = useState(true);
    const [specialCharError, setSpecialCharError] = useState(true);

    const validateEmail = (email) => {
        if (email === "") {
            return true; // this code is just for empty email, however user won't be able to submit since CTA does not allow empty string for email
        }
        return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
    };

    const handleChangeEmail = async () => {
        const newEmail = emailConfirm;

        const result = await UpdateUserEmail(token, newEmail);
        if (result.success) {
            setConfirmMessage(`Email Succesfully Updated!`);
            dispatch(updateEmail(emailConfirm));
            setTimeout(() => handleClose(), 2000);
        } else {
            // const errorArray = result.message.error;
            // console.error('API call failed:', errorArray[0].msg);
            // setConfirmMessage(`Error: ${errorArray[0].msg}, Please try again or reach out to Support`);
            setConfirmMessage(`Email already in use, Please try again or reach out to support`);
            setRedResponseBackground(true);
        }
    };

    const handleChangePassword = async () => {
        const passwordCheck = await currentPasswordChecker(currentPassword, token, userId);
        if (passwordCheck.status === 200) {
            const result = await ConfirmPasswordReset(token, newPassword);
            if (result.success) {
                setConfirmMessage(`Password Succesfully Updated!`);
                setIsPrevPasswordValid(true);
                setTimeout(() => handleClose(), 2000);
            }
            if (!result.success) {
                if (result?.status?.response?.data?.message !== undefined && result?.status?.response?.status === 402) {
                    setConfirmMessage(
                        `Error: ${result.status.response.data.message} Please try again or reach out to Support`
                    );
                } else {
                    setConfirmMessage(`Error: Please try again or reach out to Support.`);
                }
                setRedResponseBackground(true);
            }
        } else {
            setConfirmMessage(`Current password does not match our records, please try again or reset your password.`);
            setIsPrevPasswordValid(false);
        }
    };

    const submitAchievement = async () => {
        try {
            const achievementData = {
                source: "web",
                buildId: "1",
                userId,
                ownerId: null,
                roomId: null,
                serverId: "1",
                eventTs: new Date().toISOString(),
                eventName: "achievement",
                eventType: "The Final Touch",
                eventJson: {
                    count: 1,
                },
                envApi: process.env.REACT_APP_STREAM_API_ENV,
                url: process.env.REACT_APP_WEB_URL,
            };
            await sendEventsLogCustomBody(achievementData);
        } catch (error) {
            console.error("Error setting achievement:", error);
        }
    };

    const handleChangeDetails = async () => {
        try {
            let birthdayUpdated = false;

            if (birthday && !birthdaySupport) {
                // Parse "DD/MM/YYYY"
                const [dd, mm, yyyy] = birthday.split("/").map(Number);
                if (!dd || !mm || !yyyy) {
                    setErrorMessage("Invalid birthday format. Expected DD/MM/YYYY");
                    setConfirmMessage("");
                    return;
                }

                const userBirthday = `${yyyy}-${mm.toString().padStart(2, "0")}-${dd.toString().padStart(2, "0")}`;

                const dateCheck = new Date(userBirthday);
                if (
                    Number.isNaN(dateCheck.getTime()) ||
                    dateCheck.getUTCFullYear() !== yyyy ||
                    dateCheck.getUTCMonth() + 1 !== mm ||
                    dateCheck.getUTCDate() !== dd
                ) {
                    setErrorMessage("Invalid date");
                    setConfirmMessage("");
                    return;
                }

                const thirteenYearsAgo = new Date();
                thirteenYearsAgo.setFullYear(thirteenYearsAgo.getFullYear() - 13);
                if (dateCheck > thirteenYearsAgo) {
                    setErrorMessage("Error: User must be at least 13 years old.");
                    setConfirmMessage("");
                    return;
                }

                let initialBirthdayString = "";
                if (initialBirthday) {
                    if (initialBirthday instanceof Date) {
                        const year = initialBirthday.getUTCFullYear();
                        const month = String(initialBirthday.getUTCMonth() + 1).padStart(2, "0");
                        const day = String(initialBirthday.getUTCDate()).padStart(2, "0");
                        initialBirthdayString = `${year}-${month}-${day}`;
                    } else if (typeof initialBirthday === "string") {
                        initialBirthdayString = initialBirthday.split("T")[0]; // Handle "2002-06-15" or "2002-06-15T00:00:00.000Z"
                    }
                }

                if (initialBirthday && userBirthday === initialBirthdayString) {
                    console.log("No changes to birthday. Skipping update.");
                } else {
                    try {
                        console.log("Updating birthday:", userBirthday);
                        const birthdayResult = await UpdateUserBirthday(token, userBirthday, userId);
                        if (birthdayResult.status === 200) {
                            birthdayUpdated = true;
                            const formattedBirthday = formatDateToDDMMYYYY(userBirthday); // e.g., "15/06/2002"
                            setCurrentBirthday(formattedBirthday);
                            dispatch({ type: "UPDATE_BIRTHDAY", payload: formattedBirthday });
                        } else {
                            setBirthdaySupport(true);
                            setConfirmMessage("Error: Unable to update birthday. Contact support.");
                            setErrorMessage("");
                            return;
                        }
                    } catch (error) {
                        console.error("Error updating birthday:", error);
                        setBirthdaySupport(true);
                        setConfirmMessage("Error: Unable to update birthday. Contact support.");
                        setErrorMessage("");
                        return;
                    }
                }
            }

            if (firstName && country && gender) {
                await submitAchievement();
            }

            const profileData = {
                firstName,
                lastName,
                userCountry: country,
                gender,
            };

            if (username !== currentUsername) {
                profileData.displayName = username;
            }

            const profileResult = await UpdateUserProfileData(profileData);

            if (profileResult.status !== 200) {
                setConfirmMessage("Display name already in use.");
                // setRedResponseBackground(true);
                setIsValidUsername(false);
                return;
            }

            setConfirmMessage("Changes saved");
            setErrorMessage("");

            // Only decrement the birthday counter if the birthday was updated
            if (birthdayUpdated) {
                setBirthdayCounter((prev) => prev - 1);
            }

            setTimeout(() => handleClose(), 3000);
        } catch (error) {
            console.error("Error updating details:", error);
            setConfirmMessage("Error: Failed to update details. Please try again or contact support.");
        }
    };

    const handleUsernameChange = (e) => {
        setUsername(e.target.value);
        const newUsername = e.target.value;
        if (!validateUsername(newUsername)) {
            setIsValidUsername(false);
            setConfirmMessage(
                "Username must start with a letter, only contain letters, numbers, underscores, or hyphens, and be 3 - 20 characters long."
            );
        } else {
            setConfirmMessage("");
            setIsValidUsername(true);
        }
        console.log("isValidUsername", isValidUsername);
    };

    const handlePasswordChecking = (event) => {
        const minLengthRegex = /^.{8,}$/;
        const uppercaseRegex = /[A-Z]/;
        const numberRegex = /\d/;
        // eslint-disable-next-line no-useless-escape
        const specialCharacterRegex = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]/;
        setNewPassword(event.target.value);

        if (minLengthRegex.test(event.target.value)) {
            setLengthError(false);
        } else {
            setLengthError(true);
        }
        if (uppercaseRegex.test(event.target.value)) {
            setUppercaseError(false);
        } else {
            setUppercaseError(true);
        }
        if (numberRegex.test(event.target.value)) {
            setNumbersError(false);
        } else {
            setNumbersError(true);
        }
        if (specialCharacterRegex.test(event.target.value)) {
            setSpecialCharError(false);
        } else {
            setSpecialCharError(true);
        }
    };

    const handleCopyToClipboard = (value) => {
        navigator.clipboard
            .writeText(value)
            .then(() => {
                console.log("Copied to clipboard:", value);
            })
            .catch((err) => {
                console.error("Failed to copy to clipboard:", err);
            });
    };

    const formatDateToDDMMYYYY = (dateString) => {
        if (!dateString || typeof dateString !== "string") {
            console.error("Invalid date string. Expected YYYY-MM-DD");
            return "";
        }

        const dateOnly = dateString.split("T")[0];

        const [yyyy, mm, dd] = dateOnly.split("-");

        if (!dd || !mm || !yyyy || Number.isNaN(dd) || Number.isNaN(mm) || Number.isNaN(yyyy)) {
            console.error("Invalid date format. Expected YYYY-MM-DD");
            return "";
        }

        return `${dd.padStart(2, "0")}/${mm.padStart(2, "0")}/${yyyy}`;
    };

    useEffect(() => {
        const handlePageLoad = async () => {
            const userData = await getUserProfileData(token, userId);
            setBirthdaySupport(false);

            const { userBirthday, birthdayUpdateCount, displayName, firstName, lastName, userCountry, gender } =
                userData.data;
            const changesLeft = 3 - birthdayUpdateCount;
            setBirthdayCounter(changesLeft);

            setUsername(displayName);
            setCurrentUsername(displayName);
            setFirstName(firstName);
            setLastName(lastName);
            setCountry(userCountry);

            setInitialFirstName(firstName);
            setInitialLastName(lastName);
            setInitialCountry(userCountry);

            if (userBirthday !== null && userBirthday !== undefined) {
                setBirthday(formatDateToDDMMYYYY(userBirthday));
                setInitialBirthday(userBirthday);
            } else {
                setBirthday("");
            }
        };

        handlePageLoad();
    }, [token, userId]);

    const handleDisconnectSpotify = () => {
        dispatch({ type: "SPOTIFY_DELETE" });
        sessionStorage.removeItem("spotifyAccessToken");
        sessionStorage.removeItem("spotifyRefreshToken");

        console.log("Spotify disconnected successfully.");
        setTimeout(() => handleClose(), 3000);
    };

    const handleBirthdayInput = (e) => {
        let value = e.target.value.replace(/[^\d/]/g, "");

        if (value.length === 2 && birthday.length === 1) value += "/";
        if (value.length === 5 && birthday.length === 4) value += "/";

        if (value.length === 3 && value[2] !== "/") value = `${value.slice(0, 2)}/${value.slice(2)}`;
        if (value.length === 6 && value[5] !== "/") value = `${value.slice(0, 5)}/${value.slice(5)}`;

        value = value.slice(0, 10);

        setBirthday(value);

        let valid = /^\d{2}\/\d{2}\/\d{4}$/.test(value);

        if (valid) {
            const [dd, mm, yyyy] = value.split("/").map(Number);
            const now = new Date();

            if (yyyy < 1900 || yyyy > now.getFullYear()) valid = false;

            if (mm < 1 || mm > 12) valid = false;

            if (dd < 1 || dd > 31) valid = false;

            const dateObj = new Date(yyyy, mm - 1, dd);
            if (dateObj.getFullYear() !== yyyy || dateObj.getMonth() !== mm - 1 || dateObj.getDate() !== dd) {
                valid = false;
            }

            if (dateObj > now) valid = false;
        }

        setIsBirthdayInputValid(valid);
    };

    // eslint-disable-next-line react/prop-types
    const MyContainer = ({ className, children }) => (
        <div style={{ marginBottom: "-60px", width: "100%" }}>
            <BirthdayContainer className={className}>
                <div style={{ zIndex: 9999 }}>{children}</div>
            </BirthdayContainer>
        </div>
    );

    return (
        <>
            <div>
                <TitleTextContent>
                    {isEmail && "Update Your Email"}
                    {isPassword && "Update Password"}
                    {isBirthday && !birthdaySupport
                        ? "When's Your Birthday"
                        : isBirthday && birthdaySupport
                          ? "Contact Support"
                          : null}
                    {isUserData && "Edit Profile"}
                    {isContactSupport && "Contact Support"}
                    {isRequestPro && "Request A Pro Account"}
                    {isExitConsole && "Exit User Console?"}
                    {isDisconnectApp && "Disconnect Application"}
                </TitleTextContent>
                <SmallTitle>
                    {isEmail && "Change the email you use to login and receive Intraverse news."}
                    {isPassword && "Please ensure your new password meets our criteria."}
                    {isContactSupport &&
                        "To temporarily disable or permanently delete your Intraverse account, please contact our support team via email."}
                    {isRequestPro && (
                        <>
                            Upgrade to Pro for <span> premium features </span> that enhance your experience and help
                            grow your audience! Email our team for more details.
                        </>
                    )}
                    {isUserData && "Edit your profile details below."}
                    {isExitConsole && "You are about to open a new web page. Would you like to continue?"}
                    {isDisconnectApp && <>You are about to disconnect {externalAppType}, are you sure to continue?</>}
                </SmallTitle>

                {/* {isBirthday && !birthdaySupport ? (
                    <SmallSubtitle style={{ margin: "1rem 3rem" }}>
                        Add to receive a gift on your special day! You can edit up to{" "}
                        <span> {birthdayCounter} more times</span>.
                    </SmallSubtitle>
                ) : isBirthday && birthdaySupport ? (
                    <SmallSubtitle>
                        You have hit the limit for changing your birthday. Please reach out to our support team to
                        assist you with updating this information.
                    </SmallSubtitle>
                ) : null}

                {isBirthday && errorMessage !== "" && (
                    <SmallSubtitle style={{ color: "red" }}>{errorMessage}</SmallSubtitle>
                )} */}

                {/* currently a sample banner for errors, turn it into component in the future */}
                {redResponseBackground && (
                    <BannerContainer>
                        <Iconify
                            icon={SystemAlert}
                            size={"20px"}
                            mobileSize={"16px"}
                            style={{
                                margin: isMobile ? "5px 5px 5px 0" : "5px -5px 5px 0",
                            }}
                        />
                        <BannerText color="#FF8484">{confirmMessage}</BannerText>
                    </BannerContainer>
                )}

                {isEmail && (
                    <div style={{ gap: "40px" }}>
                        <LabelText> Current Email</LabelText>
                        <InputContainer readonly style={{ marginBottom: "20px" }}>
                            <CustomInput type="email" placeholder="Current Email" readonly value={userEmail} />
                        </InputContainer>

                        <LabelText> New Email</LabelText>
                        <InputContainer hasError={validateEmail(email) !== true && email !== ""}>
                            <CustomInput
                                type="email"
                                placeholder="What's your email?"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </InputContainer>
                        <TextContent hasError={validateEmail(email) !== true} fontsize="14px">
                            {validateEmail(email) !== true ? <>Invalid Email</> : <></>}
                        </TextContent>

                        <LabelText> Confirm New Email</LabelText>
                        <InputContainer hasError={email !== emailConfirm && emailConfirm !== ""}>
                            <CustomInput
                                type="email"
                                placeholder="What's your email?"
                                value={emailConfirm}
                                onChange={(e) => setEmailConfirm(e.target.value)}
                            />
                        </InputContainer>
                        {email !== "" && emailConfirm !== "" && (
                            <TextContent hasError={email !== emailConfirm} fontsize="14px">
                                {email === emailConfirm ? <></> : <>Email does not match. Try again!</>}
                            </TextContent>
                        )}
                    </div>
                )}

                {isPassword && (
                    <>
                        <LabelText> Current Password</LabelText>
                        <InputContainer hasError={!isPrevPasswordValid && currentPassword !== ""}>
                            <CustomInput
                                onChange={(e) => setCurrentPassword(e.target.value)}
                                value={currentPassword}
                                type={showPassword ? "text" : "password"}
                                placeholder="Current Password"
                            />
                            <Iconify
                                icon={showPassword ? EyeSlashIcon : EyeIcon}
                                onClick={toggleShowPassword}
                                Color={"grey"}
                                style={{
                                    height: "14px",
                                    margin: isMobile ? "5px 5px 5px 0" : "5px -5px 5px 0",
                                    cursor: "pointer",
                                }}
                            />
                        </InputContainer>
                        <TextContent hasError={!isPrevPasswordValid} fontsize="14px">
                            {isPrevPasswordValid ? <></> : <>{confirmMessage}</>}
                        </TextContent>

                        <LabelText> New Password</LabelText>
                        <InputContainer>
                            <CustomInput
                                type={showPassword ? "text" : "password"}
                                placeholder="New Password"
                                value={newPassword}
                                onChange={(event) => {
                                    handlePasswordChecking(event);
                                }}
                            />
                            <Iconify
                                icon={showPassword ? EyeSlashIcon : EyeIcon}
                                onClick={toggleShowPassword}
                                Color={"grey"}
                                style={{
                                    height: "14px",
                                    margin: isMobile ? "5px 5px 5px 0" : "5px -5px 5px 0",
                                    cursor: "pointer",
                                }}
                            />
                        </InputContainer>
                        <PasswordChecker password={newPassword} />

                        <LabelText> Confirm New Password</LabelText>
                        <InputContainer hasError={newPassword !== newPasswordConfirm && newPasswordConfirm !== ""}>
                            <CustomInput
                                type={showPassword ? "text" : "password"}
                                placeholder="Confirm New password"
                                value={newPasswordConfirm}
                                onChange={(e) => setNewPasswordConfirm(e.target.value)}
                            />
                            {/* <Iconify
                                icon={showPassword ? "ph:eye-slash-duotone" : "mdi:eye"}
                                onClick={toggleShowPassword}
                                Color={"grey"}
                                style={{ height: "27px", margin: "5px -5px 5px 0", cursor: "pointer" }}
                            />  */}
                            <Iconify
                                icon={showPassword ? EyeSlashIcon : EyeIcon}
                                onClick={toggleShowPassword}
                                Color={"grey"}
                                style={{
                                    height: "14px",
                                    margin: isMobile ? "5px 5px 5px 0" : "5px -5px 5px 0",
                                    cursor: "pointer",
                                }}
                            />
                        </InputContainer>
                        {newPassword !== "" && newPasswordConfirm !== "" && (
                            <TextContent hasError={newPassword !== newPasswordConfirm} fontsize="14px">
                                {newPassword === newPasswordConfirm ? (
                                    <>
                                        <GreenFeatureCheckmark height={"15px"} style={{ verticalAlign: "bottom" }} />{" "}
                                        Passwords Match!
                                    </>
                                ) : (
                                    <>Passwords do not match</>
                                )}
                            </TextContent>
                        )}
                    </>
                )}

                {isUserData && (
                    <>
                        <FadeCard enableMobileFade>
                            <LabelText>Username</LabelText>
                            <InputContainer hasError={!isValidUsername}>
                                <CustomInput type="text" value={username} onChange={handleUsernameChange} />
                            </InputContainer>
                            <TextContent hasError={!isValidUsername} fontsize="14px">
                                {isValidUsername ? <></> : <>{confirmMessage}</>}
                            </TextContent>
                            <DetailDoubleColumn>
                                <LabelText>First Name</LabelText>
                                <InputContainer hasError={!isValidFirstName}>
                                    <CustomInput
                                        type="text"
                                        value={firstName}
                                        onChange={(e) => {
                                            const value = e.target.value.trim();
                                            const isValid = /^[a-zA-Z\s'-]*$/.test(value);
                                            if (isValid) {
                                                setFirstName(value);
                                                setIsValidFirstName(true);
                                            } else {
                                                setIsValidFirstName(false);
                                            }
                                        }}
                                    />
                                </InputContainer>

                                <TextContent hasError={!isValidFirstName} fontsize="14px">
                                    {isValidFirstName ? (
                                        <></>
                                    ) : (
                                        <>First name must start with a letter and contain only letters, spaces</>
                                    )}
                                </TextContent>
                            </DetailDoubleColumn>
                        </FadeCard>
                        <FadeCard enableMobileFade>
                            <DetailDoubleColumn>
                                <LabelText>Last Name</LabelText>
                                <InputContainer hasError={!isValidLastName}>
                                    <CustomInput
                                        type="text"
                                        value={lastName}
                                        onChange={(e) => {
                                            const value = e.target.value.trim();
                                            const isValid = /^[a-zA-Z\s'-]*$/.test(value);
                                            if (isValid) {
                                                setLastName(value);
                                                setIsValidLastName(true);
                                            } else {
                                                setIsValidLastName(false);
                                            }
                                        }}
                                    />
                                </InputContainer>
                                <TextContent hasError={!isValidLastName} fontsize="14px">
                                    {isValidLastName ? (
                                        <></>
                                    ) : (
                                        <>Last name must start with a letter and contain only letters, spaces</>
                                    )}
                                </TextContent>
                            </DetailDoubleColumn>
                        </FadeCard>
                        <FadeCard enableMobileFade>
                            <LabelText>Birthday</LabelText>
                            {!birthdaySupport && birthdayCounter >= 1 ? (
                                <BirthdayContainer>
                                    <SmallSubtitle style={{ paddingLeft: "5px" }}>
                                        Add to receive a gift on your special day! You can edit up to
                                        <span> {birthdayCounter} more times</span>.
                                    </SmallSubtitle>
                                    {errorMessage !== "" && (
                                        <SmallSubtitle style={{ color: "red" }}>{errorMessage}</SmallSubtitle>
                                    )}
                                    <StyledBirthdaySelector>
                                        <DateInputWrapper>
                                            {/* <DateInput
                                                ref={dateInputRef}
                                                popperPlacement="top"
                                                calendarContainer={MyContainer}
                                                selected={birthday}
                                                onChange={(date) => {
                                                    setBirthday(date);
                                                }}
                                                dateFormat="MM/dd/yyyy"
                                                maxDate={new Date()}
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                fixedHeight
                                                showTimeInput={false}
                                                placeholderText="Click to select a date"
                                            /> */}
                                            <TextBirthdayInput
                                                type="text"
                                                value={birthday || ""}
                                                onChange={handleBirthdayInput}
                                                placeholder="DD/MM/YYYY"
                                            />
                                            <Iconify
                                                icon={CalendarIcon}
                                                Color={"grey"}
                                                mobileSize={"20px"}
                                                size={"14px"}
                                                style={{
                                                    margin: "5px 8px 5px 0",
                                                    cursor: "pointer",
                                                }}
                                            />
                                        </DateInputWrapper>
                                    </StyledBirthdaySelector>
                                </BirthdayContainer>
                            ) : (
                                <BirthdayContainer>
                                    <SmallSubtitle style={{ paddingLeft: "5px", marginBottom: "5px" }}>
                                        You reached your edit limit. Contact <span> support@terrazero.com</span> to
                                        change.
                                    </SmallSubtitle>
                                    <DateInputWrapper>
                                        <TextBirthdayInput
                                            type="text"
                                            value={birthday || ""}
                                            onChange={handleBirthdayInput}
                                            placeholder="DD/MM/YYYY"
                                            disabled
                                        />

                                        <Iconify
                                            icon={CalendarIcon}
                                            Color={"grey"}
                                            mobileSize={"20px"}
                                            size={"14px"}
                                            cursor={"pointer"}
                                            style={{
                                                margin: "5px 7px 5px 0px",
                                            }}
                                        />
                                    </DateInputWrapper>
                                </BirthdayContainer>
                            )}
                        </FadeCard>
                        <FadeCard enableMobileFade>
                            <LabelText>Country</LabelText>
                            <InputContainer>
                                <InputSelect id="country" value={country} onChange={(e) => setCountry(e.target.value)}>
                                    <InputSelectOption value="">Select a country</InputSelectOption>
                                    <InputSelectOption value="United States">United States</InputSelectOption>
                                    <InputSelectOption value="Canada">Canada</InputSelectOption>
                                </InputSelect>
                            </InputContainer>
                        </FadeCard>
                    </>
                )}

                {(isContactSupport || isRequestPro) && (
                    <InputContainer style={{ marginTop: "2rem" }}>
                        <Iconify
                            icon={MailIcon}
                            Color={"grey"}
                            mobileSize={"20px"}
                            size={"20px"}
                            cursor={"pointer"}
                            style={{
                                margin: "5px 10px 5px 10px",
                            }}
                        />
                        <CustomInput
                            type="text"
                            placeholder="Contact Support"
                            value={"support@terrazero.com"}
                            readOnly
                        />
                        <Iconify
                            icon={CopyIcon}
                            Color={"grey"}
                            mobileSize={"20px"}
                            size={"20px"}
                            cursor={"pointer"}
                            style={{
                                margin: "5px 7px 5px 0px",
                            }}
                            onClick={() => handleCopyToClipboard("support@terrazero.com")}
                        />
                    </InputContainer>
                )}

                <ButtonDiv>
                    {isEmail && (
                        <FixedButtonWrapper>
                            <Button
                                variant={"PurpleButton"}
                                label="Update My Email"
                                buttonWidth="100%"
                                margin={"0.5rem 0rem 0rem 0rem"}
                                disabled={
                                    (validateEmail(email) !== true && validateEmail(emailConfirm) !== true) ||
                                    email !== emailConfirm ||
                                    email === "" ||
                                    emailConfirm === ""
                                }
                                onClick={() => handleChangeEmail()}
                            />
                        </FixedButtonWrapper>
                    )}
                    {isPassword && (
                        <FixedButtonWrapper>
                            <Button
                                variant={"PurpleButton"}
                                label="Update My Password"
                                buttonWidth="100%"
                                margin={"1rem 0rem 1rem 0rem"}
                                disabled={
                                    lengthError ||
                                    uppercaseError ||
                                    numberError ||
                                    specialCharError ||
                                    currentPassword === "" ||
                                    newPassword !== newPasswordConfirm
                                }
                                onClick={() => handleChangePassword()}
                            />
                        </FixedButtonWrapper>
                    )}
                    {isUserData && (
                        <DetailModal>
                            <FixedButtonWrapper>
                                <Button
                                    margin="1rem 0rem 1rem 0rem"
                                    buttonWidth="100%"
                                    variant="PurpleButton"
                                    backgroundColor={setColor.brightViolet}
                                    label="Update My Details"
                                    disabled={
                                        !validateUsername(username) ||
                                        firstName === "" ||
                                        lastName === "" ||
                                        (username === currentUsername &&
                                            firstName === initialFirstName &&
                                            lastName === initialLastName &&
                                            country === initialCountry &&
                                            ((birthday === null && initialBirthday === null) ||
                                                (birthday &&
                                                    initialBirthday &&
                                                    // birthday.getTime() === initialBirthday.getTime() &&
                                                    !isBirthdayInputValid)))
                                    }
                                    onClick={() => handleChangeDetails()}
                                />
                            </FixedButtonWrapper>
                        </DetailModal>
                    )}

                    {(isContactSupport || isRequestPro) && (
                        <>
                            <FixedButtonWrapper>
                                <Button
                                    margin="1rem 0rem 1rem 0rem"
                                    buttonWidth="100%"
                                    variant="PurpleButton"
                                    backgroundColor={setColor.brightViolet}
                                    label="Email To Contact Support"
                                    onClick={() => {
                                        window.location = "mailto:hello@terrazero.com";
                                    }}
                                />
                            </FixedButtonWrapper>
                        </>
                    )}

                    {isExitConsole && externalAppType === "Spotify" && (
                        <FixedButtonWrapper>
                            <Button
                                margin="1rem 0rem 1rem 0rem"
                                buttonWidth="100%"
                                variant="PurpleButton"
                                backgroundColor={setColor.brightViolet}
                                label="Continue"
                                onClick={() => {
                                    handleSpotifyAuth(process.env.REACT_APP_WEB_URL);
                                }}
                            />
                        </FixedButtonWrapper>
                    )}

                    {isDisconnectApp && externalAppType === "Spotify" && (
                        <FixedButtonWrapper>
                            <Button
                                margin="1rem 0rem 1rem 0rem"
                                buttonWidth="100%"
                                variant="PurpleButton"
                                backgroundColor={setColor.brightViolet}
                                label="Continue"
                                onClick={() => {
                                    handleDisconnectSpotify();
                                }}
                            />
                        </FixedButtonWrapper>
                    )}
                </ButtonDiv>
            </div>

            <ResponseMessageContainer isPassword={isPassword}>
                {confirmMessage &&
                    !redResponseBackground &&
                    isValidUsername &&
                    isValidFirstName &&
                    isValidLastName &&
                    isPrevPasswordValid && (
                        <ConfirmResponseMessage
                            style={{
                                color: `#93ECC7`,
                            }}
                        >
                            {confirmMessage}
                        </ConfirmResponseMessage>
                    )}
            </ResponseMessageContainer>
        </>
    );
}

EditContentModal.propTypes = {
    handleClose: PropTypes.func,
    setCurrentBirthday: PropTypes.func,
    userEmail: PropTypes.string,
    isEmail: PropTypes.bool,
    isPassword: PropTypes.bool,
    isBirthday: PropTypes.bool,
    isUserData: PropTypes.bool,
    isRequestPro: PropTypes.bool,
    isContactSupport: PropTypes.bool,
    isExitConsole: PropTypes.bool,
    isDisconnectApp: PropTypes.bool,
    externalAppType: PropTypes.string,
};

const DetailModal = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    // gap: 5px;
    overflow-x: hidden;
    position: relative;

    @media (max-width: 768px) {
        padding-bottom: 100px;
    }
`;
// const DetailDoubleRow = styled.div`
//     display: flex;
//     flex-direction: row;
//     justify-content: center;
//     width: 100%;
//     gap: 10px;
// `;
const DetailDoubleColumn = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
`;

const TitleTextContent = styled.h1`
    color: ${setColor.circularProgress};
    font-family: "Barlow", sans-serif;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: capitalize;
    letter-spacing: 0.5px;
    text-align: center;
    margin-bottom: 12px;
    margin-top: 12px;

    @media (max-width: 768px) {
        font-size: 24px;
        margin: 10px 0;
    }
`;
const TextContent = styled.p`
    color: ${(props) => (props.hasError ? setColor.errorColor : setColor.circularProgress)};
    text-align: left;
    font-family: ${setFont.barlow}, sans-serif;
    font-size: ${(props) => (props.fontsize ? props.fontsize : "13px")};
    font-style: normal;
    line-height: normal;
    margin: 5px;
    letter-spacing: 0.5px;
    font-weight: 400;

    @media (max-width: 768px) {
        margin-bottom: 20px;
    }
`;

const SmallTitle = styled.p`
    text-align: center;
    color: ${setColor.circularProgress};
    font-family: ${setFont.barlow}, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    margin-top: 0rem;
    letter-spacing: 0px;

    & > span {
        color: ${setColor.spanTextcolor2};
        font-weight: 700;
    }

    @media (max-width: 768px) {
        font-size: 18px;
        margin: 15px 0;
    }
`;

const SmallSubtitle = styled.p`
    text-align: left;
    color: ${setColor.circularProgress};
    font-family: ${setFont.barlow}, sans-serif;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    letter-spacing: 0.5px;

    & > span {
        color: ${setColor.spanTextcolor2};
        font-weight: 700;
    }

    @media (max-width: 425px) {
        font-size: 14px;
        margin: 5px 0;
    }
`;

const ConfirmResponseMessage = styled.p`
    text-align: center;
    // background: ${setColor.linearGreen};
    background: ${(props) => (props.error ? setColor.linearErrorRed : setColor.linearGreen)};
    color: ${setColor.greenLight};
    font-family: ${setFont.barlow}, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    leading-trim: both;
    margin-top: 0rem;
    margin-bottom: 5px;
    width: 100%;
    padding: 10px 20px;
    height: auto;

    & > span {
        color: ${setColor.accent4};
        font-weight: 700;
    }
`;
const LabelText = styled.p`
    text-align: left;
    color: ${setColor.circularProgress};
    font-family: ${setFont.barlow}, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    margin-top: 1rem;
    margin-bottom: 0.3rem;
    margin-left: 5px;
    text-transform: capitalize;
    letter-spacing: 0.5px;

    @media (max-width: 425px) {
        font-size: 14px;
        margin-top: 5px;
    }

    // @media (max-height: 768px) {
    //     margin-top: 5px;
    //     font-size: 18px
    // }

    @media (max-width: 768px) {
        margin-top: 5px;
        font-size: 18px;
    }
`;

const CustomInput = styled.input`
    flex: 1;
    border: none;
    background: ${(props) => (props.readonly ? setColor.disabledGrey : "none")};
    width: 90%;
    height: 40px;
    padding-left: 10px;
    color: ${(props) => (props.readonly ? "#9D9D9D" : setColor.white)};
    font-style: ${setFont.barlow};
    leading-trim: both;
    text-edge: cap;
    font-family: "Barlow";
    font-weight: 600;
    line-height: normal;

    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
        -webkit-box-shadow: ${() => `0 0 0 30px ${setColor.purpleDarkTwo} inset !important`};
        -webkit-text-fill-color: red !important;
    }

    @media (max-width: 768px) {
        height: 48px;
        padding-left: 10px;
    }
`;
const InputSelect = styled.select`
    flex: 1;
    border: none;
    background: none;
    width: 90%;
    height: 40px;
    padding-left: 10px;
    padding-right: 60px;
    color: ${setColor.white};
    background: url(${Chevron}) no-repeat right 10px center;
    background-size: 14px;

    appearance: none;

    &:focus {
        outline: none;
    }

    @media (max-width: 768px) {
        height: 48px;
        padding-left: 10px;
        background: url(${Chevron}) no-repeat right 10px center;
        background-size: 20px;
    }
`;
const InputSelectOption = styled.option`
    flex: 1;
    border: none;
    background: ${setColor.inputBgColor};
    width: 90%;
    height: 40px;
    padding-left: 10px;
    color: ${setColor.white};
`;

const InputContainer = styled.div`
    display: flex;
    flex: 1;
    border-radius: 5px;
    justify-content: center;
    background: ${setColor.black40};
    cursor: pointer;
    height: 40px;
    align-items: center;
    border: ${(props) =>
        props.readonly
            ? "none"
            : props.hasError
              ? `1px solid var(--Banners-Red, ${setColor.errorColor})`
              : `1px solid ${setColor.brightVioletTransparent}`};

    &:focus-within {
        border: ${(props) =>
            props.readonly
                ? "none"
                : props.hasError
                  ? `1px solid var(--Banners-Red, ${setColor.errorColor})`
                  : `1px solid ${setColor.brightViolet100 || "#DD42CE"}`};
        outline: none;
    }

    & input:focus,
    & select:focus {
        outline: none;
    }

    @media (max-width: 768px) {
        width: 100%;
        // margin-bottom: 20px;
        height: 48px;
    }

    @media (min-width: 768px) and (max-width: 1024px) {
        width: 100%;
    }
`;

const ButtonDiv = styled.div`
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const StyledBirthdaySelector = styled.div`
    display: flex;
    flex-direction: column;
    margin: 0.5rem 0rem 0rem 0rem;
`;

const BirthdayContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    @media (max-width: 768px) {
        margin-bottom: 20px;
    }
`;

const DateInputWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    border-radius: 5px;
    background: ${setColor.black40};
    height: 40px;
    border: 1px solid ${setColor.brightVioletTransparent};
    box-sizing: border-box;

    &:focus-within {
        border: 1px solid ${setColor.brightViolet100 || "#DD42CE"};
    }

    @media (max-width: 768px) {
        height: 48px;
    }
`;

const DateInput = styled(DatePicker)`
    flex: 1;
    border: none;
    background: none;
    width: 100%;
    height: 35px;
    padding-left: 10px;
    font-size: 14px;
    color: ${setColor.white};

    &::placeholder {
        color: #9d9d9d;
    }

    &[disabled] {
        color: #9d9d9d;
        background: transparent;
    }

    &:focus {
        outline: none;
    }

    @media (max-width: 768px) {
        height: 48px;
        padding-left: 10px;
    }
`;

const ResponseMessageContainer = styled.div`
    position: fixed;
    bottom: ${(props) => (props.isPassword ? "20vh" : "15vh")};
    left: 50%;
    transform: translateX(-50%);
    width: 25%;
    height: 50px;
    text-align: center;
    z-index: 9999;
    pointer-events: none;

    @media (max-height: 900px) {
        bottom: 0vh;
    }

    @media (max-height: 1150px) {
        bottom: 2vh;
    }

    @media (max-height: 900px) and (max-width: 768px) {
        bottom: 15vh;
    }

    @media (max-height: 1150px) and (max-width: 768px) {
        bottom: 17vh;
    }

    @media (max-width: 768px) {
        width: 100%;
        left: 0;
        // bottom: 12vh;
        transform: translateX(0);
        height: 35px;
        padding: 10px 25px;
        box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
    }
`;

const FixedButtonWrapper = styled.div`
    width: 100%;
    @media (max-width: 768px) {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 10px 25px;
        z-index: 999999;
    }
`;

const BannerContainer = styled.div`
    margin-top: 20px;
    display: flex;
    width: 100%;
    padding: 20px;
    align-items: center;
    gap: 10px;
    border-radius: 5px;
    height: 5vh;
    background: var(--banners-dark-red-90, rgba(102, 16, 16, 0.9));
`;

const BannerText = styled.p`
    color: ${(props) => (props.color ? props.color : setColor.white)};
    font-family: ${setFont.barlow}, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
`;

const TextBirthdayInput = styled.input`
    padding: 10px 10px 10px 10px;
    color: white;
    font-family: ${setFont.barlow}, sans-serif;
    width: 100%;
    background-color: transparent;
    border: 0px solid transparent;
    outline: none;
`;
